import { useEffect, useState, useCallback } from 'react';
import styles from './Broadcast.module.css';

interface Props {
  message: string;
  type: 'info' | 'success' | 'warning' | 'error';
  onDone: () => void;
}

const TYPE_CONFIG = {
  info:    { icon: 'ℹ️',  bg: 'rgba(78,205,196,0.15)', border: '#4ECDC4' },
  success: { icon: '✅',  bg: 'rgba(76,175,80,0.15)',  border: '#4CAF50' },
  warning: { icon: '⚠️', bg: 'rgba(255,152,0,0.15)',  border: '#FF9800' },
  error:   { icon: '❌', bg: 'rgba(244,67,54,0.15)',  border: '#F44336' },
};

export default function Broadcast({ message, type, onDone }: Props) {
  const [visible, setVisible] = useState(false);
  const [leaving, setLeaving] = useState(false);

  useEffect(() => {
    // 入场动画
    requestAnimationFrame(() => setVisible(true));
    // 2.3秒后开始退场
    const leaveTimer = setTimeout(() => setLeaving(true), 2300);
    // 2.7秒后通知父组件移除
    const doneTimer = setTimeout(() => { onDone(); }, 2700);
    return () => { clearTimeout(leaveTimer); clearTimeout(doneTimer); };
  }, [onDone]);

  const cfg = TYPE_CONFIG[type];

  return (
    <div
      className={`${styles.overlay} ${visible ? styles.visible : ''} ${leaving ? styles.leaving : ''}`}
    >
      <div className={styles.card} style={{ background: cfg.bg, borderColor: cfg.border }}>
        <span className={styles.icon}>{cfg.icon}</span>
        <span className={styles.msg}>{message}</span>
      </div>
    </div>
  );
}
